import { c as _c } from "react/compiler-runtime";
import { type FC } from 'react';
import { ModalContent } from '@components/modal/ModalContent';
import { Button, Flex, Text } from '@endurancewarranty/ui';
export type Props = {
  onClose: () => void;
};
export const AchPaymentMethodNotAllowedModal: FC<Props> = t0 => {
  const $ = _c(6);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-2"><Text.Header fontWeight="medium">ACH Payment Not Allowed</Text.Header></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <Flex justify="end" className="mt-4 gap-2"><Button name="confirm-ach-not-allowed" variant="primary" width="fit" onClick={onClose}>Ok</Button></Flex>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text.Body align="left">We cannot accept ACH monthly payments for this sale. Please choose a different payment method.</Text.Body>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <ModalContent header={t1} footer={t2}>{t3}</ModalContent>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};